import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};

window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as nav from './scripts/nav';
nav.init();

import * as historyBack from './scripts/history-back';
historyBack.init();

import * as playVideo from './scripts/play-video';
playVideo.init();

import * as externalVideo from './scripts/external-video';
externalVideo.init();

import * as actionChanger from '@elements/action-changer';
actionChanger.init();